<script lang="ts">
	import { onMount } from "svelte";
	import { draw, fade } from "svelte/transition";
	import { fadeUp } from "$lib/transitions";
	let mounted = false;
	onMount(() => {
		mounted = true;
	});
</script>

{#if mounted}
	<svg
		style="width: 3rem; width: 3rem; margin: 0 auto 1rem auto"
		viewBox="0 0 285 285"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<circle
			transition:draw="{{ duration: 400, delay: 0 }}"
			stroke-width="10"
			cx="142.5"
			cy="142.5"
			r="115"
			fill="none"
			stroke="currentColor"></circle>
		<path
			transition:draw="{{ duration: 400, delay: 700 }}"
			d="M94 146.613C98.5 157.5 108.5 185 122.001 173.995C143 156.878 167.5 136 195 117"
			stroke="currentColor"
			stroke-width="10"
			stroke-linecap="round"></path>
	</svg>
{/if}
